import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import type { AssessmentKind, AttemptStatus, TestStatus } from '../types';

const TEST_VARIANTS: Record<TestStatus, 'default' | 'secondary' | 'outline'> = {
  published: 'default',
  draft: 'outline',
  archived: 'secondary',
};

/** Test status chip — staff surfaces only (pupil payloads carry no status). */
export function TestStatusBadge({ status }: { status: TestStatus }) {
  const { t } = useTranslation(['assessments']);
  return <Badge variant={TEST_VARIANTS[status]}>{t(`assessments:status.${status}`)}</Badge>;
}

const ATTEMPT_VARIANTS: Record<AttemptStatus, 'default' | 'secondary' | 'outline'> = {
  in_progress: 'outline',
  submitted: 'secondary',
  graded: 'default',
};

export function AttemptStatusBadge({ status }: { status: AttemptStatus }) {
  const { t } = useTranslation(['assessments']);
  return (
    <Badge variant={ATTEMPT_VARIANTS[status]}>{t(`assessments:attemptStatus.${status}`)}</Badge>
  );
}


/** The journal work kind (контрольна/тематична/…) — every reader shape
 *  carries it, so pupils see it too. `current` is the unmarked default and
 *  renders nothing: a badge on every row would say nothing on any. */
export function AssessmentKindBadge({ kind }: { kind: AssessmentKind }) {
  const { t } = useTranslation(['assessments']);
  if (kind === 'current') return null;
  return <Badge variant="outline">{t(`assessments:kinds.${kind}`)}</Badge>;
}
